import React, {useState} from 'react'
import {FilePond} from "react-filepond";


import {API_HOST, getToken} from '../../config/config';
import 'filepond/dist/filepond.min.css'


export default function DragAndDrop(props) {
  const [pond, setPond] = useState(null)

  return (
    <FilePond
      ref={(ref) => (setPond(ref))}
      allowMultiple={true}
      maxFiles={10}
      chunkUploads={true}
      chunkSize={5000000} // 5MB
      onaddfile={(error, file) => {
        if (!error) {
          file.setMetadata('filename', file.filename);
        } else {
          console.error('Error adding file:', error);
        }
      }}
      onaddfilestart={(file => {
        props.setFileIsUploading(true);
      })}
      onprocessfile={(error, file) => {
        // Called after each individual file is processed
        if (pond) {
          const allFilesProcessed = pond.getFiles().every(f => f.status === 5); // 5 = PROCESSING_COMPLETE
          if (allFilesProcessed) {
            props.setUploadFiles(pond.getFiles());
            props.setFileIsUploading(false);
          }
        }
      }}
      onprocessfiles={()=>{
        props.setUploadFiles(pond.getFiles())
        props.setFileIsUploading(false);
      }}
      onremovefile={(error, file) => {
        props.setUploadFiles(pond.getFiles())
        // Reset upload state if no files remain
        if (pond && pond.getFiles().length === 0) {
          props.setFileIsUploading(false);
        }
      }}
      onprocessfilerevert={() => {
        // Reset upload state when file is removed after upload
        if (pond && pond.getFiles().length === 0) {
          props.setFileIsUploading(false);
        }
      }}
      server={{
        url:`${API_HOST}upload`,
        headers: {
          'Authorization': 'Bearer ' + getToken(),
        },
        revert: (uniqueFileId, load) => {
          // Datei aus der Liste entfernen, unabhängig vom Ergebnis des
          // serverseitigen Aufräumens (verhindert, dass ein fehlgeschlagener
          // Upload beim Klick auf "X" wieder im Fehler-/Retry-Zustand landet)
          fetch(`${API_HOST}upload`, {
            method: 'DELETE',
            headers: {
              'Authorization': 'Bearer ' + getToken(),
            },
            body: uniqueFileId,
          }).finally(() => load())
        },
      }}
      name="file"
      labelIdle='Ziehen Sie Ihre Dateien (max. 10 pro Upload) hierher oder <span class="filepond--label-action">wählen Sie diese aus</span>'
      credits={false}
      labelFileProcessing="Dateien werden hochgeladen"
      labelFileProcessingComplete="Dateien hochgeladen"
      labelTapToUndo="rückgängig"
      labelTapToCancel="abbrechen"
    />
  )
}

